module.exports = __webpack_public_path__ + "img/auth-bg2.9d2d6827.jpg";